import { FC } from "react";
import { Controller } from "react-hook-form";
// import { ITextFieldProps, TextField } from "office-ui-fabric-react";
import * as React from "react";
import { HookFormProps } from "./HookFormProps";
import { ITextFieldProps, TextField, Label, Stack } from "@fluentui/react";
import { LimaNotice, LIMA_TEXTNOTICETYPE } from "./LimaNotice";
import { useTranslation } from "react-i18next";

type LimaControledTextFieldV4Type = {
  limaLabel?: string;
  labelPosition?: LimaTextFiledTitlePlace;
};

export enum LimaTextFiledTitlePlace {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
  NONE = "none",
}

export const LimaControledTextFieldV4: FC<HookFormProps & ITextFieldProps & LimaControledTextFieldV4Type> = (
  props: HookFormProps & ITextFieldProps & LimaControledTextFieldV4Type
) => {
  const newLocal: string = typeof props.defaultValue === "string" ? props.defaultValue : "";
  const { t } = useTranslation();

  return (
    <Stack
      horizontal={
        props.labelPosition !== undefined && props.labelPosition === LimaTextFiledTitlePlace.HORIZONTAL ? true : false
      }
    >
      {props.labelPosition !== LimaTextFiledTitlePlace.NONE && props.limaLabel && (
        <Stack.Item>
          <Label>{props.limaLabel} </Label>
        </Stack.Item>
      )}
      <Stack.Item grow={1}>
        <Controller
          name={props.name}
          control={props.control}
          rules={props.rules}
          defaultValue={newLocal}
          render={({ field: { onChange, onBlur, name: fieldName, value }, fieldState: { error } }) => (
            <>
              <TextField
                {...props}
                onChange={onChange}
                value={typeof value == "string" ? value : ""}
                onBlur={onBlur}
                name={fieldName}
                // errorMessage={error && error.message}
                defaultValue={undefined}
              />
              {error && (
                <LimaNotice noticeType={LIMA_TEXTNOTICETYPE.ERROR}>{t(`tpmain:error.${error.type}`)}</LimaNotice>
              )}
            </>
          )}
        />
      </Stack.Item>
    </Stack>
  );
};
